"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = require("../config");
var React = require("react");
var react_1 = require("react");
var Cookie = require("js-cookie");
var contextManage_1 = require("../contextManage");
var person_user_image_1 = require("../static/images/person-user-image");
var legal_user_image_1 = require("../static/images/legal-user-image");
var SelectUserTypeComponent = function (props) {
    var context = react_1.useContext(contextManage_1.DeviceTaskContext);
    var chooseGetIdCardInfoType = function () {
        var deviceType = Cookie.get("IdCardType") || "";
        if (deviceType) {
            console.log("已经查到读卡器驱动");
            context.setStatus(config_1.TASKTYPE.idCard);
        }
        else {
            // 去手工登录
            console.log("没绑定读卡器，去手动登录");
            context.setStatus(config_1.TASKTYPE.manualLogin);
        }
    };
    // 初始化就开始加载驱动脚本
    return React.createElement("div", null,
        React.createElement("div", { className: "status", key: 1 },
            React.createElement("p", null, "\u5F53\u524D\u4E8B\u9879\u6CD5\u4EBA\u7528\u6237\u548C\u4E2A\u4EBA\u7528\u6237\u5747\u53EF\u529E\u7406"),
            React.createElement("p", null, "\u8BF7\u63D0\u9192\u7528\u6237\u9009\u62E9\u5BF9\u5E94\u8EAB\u4EFD\u8FDB\u884C\u529E\u7406")),
        React.createElement("div", { className: "payload" },
            React.createElement("img", { onClick: function () {
                    props.selectUserType(config_1.COMMON_VARIABLE.person);
                    chooseGetIdCardInfoType();
                }, style: { width: "150px", height: "150px", marginRight: "120px" }, src: person_user_image_1.default }),
            React.createElement("img", { onClick: function () {
                    props.selectUserType(config_1.COMMON_VARIABLE.legal);
                    chooseGetIdCardInfoType();
                }, style: { width: "150px", height: "150px" }, src: legal_user_image_1.default })));
};
exports.default = SelectUserTypeComponent;
